import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const dispatcherGroupsAdapter = getAdapter();

const dispatcherGroupsSlice = createSlice({
  name: 'dispatcherGroups',
  initialState: dispatcherGroupsAdapter.getInitialState(),
  reducers: {
    setDispatcherGroups: (state, { payload: { dispatcherGroups } }) => {
      dispatcherGroupsAdapter.setAll(state, dispatcherGroups);
    },
  },
});

const selectors = dispatcherGroupsAdapter.getSelectors(({ dispatcherGroups }) => dispatcherGroups);

export const getDispatcherGroupsIncludingDeleted = (state) => selectors.selectAll(state);

export const getDispatcherGroups = (state) => getDispatcherGroupsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setDispatcherGroups,
} = dispatcherGroupsSlice.actions;

export default dispatcherGroupsSlice.reducer;
